import './IicReport.css';
import axios, {AxiosResponse} from 'axios';
import React, { useEffect, useState, useRef } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import { Api } from "../../../../helpers/Api";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from '../Spinner/LoadingSpinner';
import { connect } from "react-redux";
import { jsPDF } from "jspdf";
import Blob from "blob";
import dateFormat from '../../../../helpers/DateFormate';
import Moment from 'moment';
const IicReport = () => {
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const parms = useParams();

    const load = (id) => {
        Api.call(`/getReport/${id}`).then(post => {
            setData(post)
            console.log(post);
            setTimeout(() => {
                console.log(data);
            }, 2000)
        }).catch(console.log).finally(() => {
            console.log(data);
        });
    }

    const nl2br = (str = '', is_xhtml) => {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        str = (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        return str;
    }

    const dataSet = (url)=>{
        let imagecount = 0; 
        axios.get(url?.replace("itmatic.io", "codebrigade.in"), { responseType: 'blob' })
        .then((response) => {
            // if (!response.ok) {
            //     throw new Error(`HTTP error! status: ${response.status}`);
            // }
            return response.data;
        })
        .then((blob) => {
            const reader = new FileReader();

            // Use a promise to handle FileReader
            return new Promise((resolve, reject) => {
                reader.onloadend = () => {
                    resolve(reader.result); // Base64 string
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob); // Read the Blob as Base64
            });
        })
        .then((base64String) => {
          return base64String;
        })
        .catch((error) => {
            console.error('Error fetching the image:', error);
        })
    }

    useEffect(() => {
        if (data) {
            document.getElementById("outcomes").innerHTML = nl2br(data.outcomes);
            document.getElementById("Objective").innerHTML = nl2br(data.objective);
        }
    }, [data?.outcomes, data?.Description])

    useEffect(() => {
        load(parms.id)
    }, [parms.id])

    const wordFormat = () => {
        var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
        var postHtml = "</body></html>";

        var html = preHtml + document.getElementById("page").innerHTML + postHtml;

        var blob = new Blob(['\ufeff', html], {
            type: 'application/msword'
        });

        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);


        var filename = data?.template?.name ? data?.template?.name + '.doc' : 'document.doc';


        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {

            downloadLink.href = url;
            downloadLink.download = filename;
            downloadLink.click();
        }

        document.body.removeChild(downloadLink);
    }

        return (
            <div style={{ width: "920px", boxSizing:"revert" }} className='container p-3' >
                <div style={{ width: "920px" }} className='Form-buttons mt-1'>
                    <button onClick={wordFormat} className='cancel mb-3'>Download</button>
                </div> 
                <div style={{ width: "920px"}} id="page">
                    <table width="920px" style={{width:"100%"}} align="center" cellspacing='0' cellpadding='10'>
                        <tr>
                            <td align='left'><img src='https://events.chitkara.edu.in/images/logo2.png' alt="Logo" /></td>

                            <td align="right"><img src='https://events.chitkara.edu.in/images/report-logo2.png' alt="Logo" /></td>
                        </tr>
                    </table>
                    <table width="920px" style={{width:"100%"}} align="center" cellspacing='0' cellpadding='10'>
                        <tr>
                            <td><hr className='divider' style={{height:"2px", opacity: "unset"}}/></td>
                        </tr>
                    </table>

                    <table align="center" class="report-table">
                        <tr>
                            <th colspan="3" className='report-heading' style={{ border: "1px solid black" , borderCollapse: "collapse" }}>
                                Title: {data?.template?.name}
                            </th>
                        </tr>
                        <tr>
                            <td style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>1</td>
                            <td style={{ width: "25%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}><b>Type of Activity</b></td>
                            <td style={{ width: "65%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>{data?.typeOfActivity}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>2</td>
                            <td style={{ width: "25%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}><b>PROGRAM THEME (KEYWORDS)</b></td>
                            <td style={{ width: "65%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>{data?.programTheme}</td>
                        </tr>
                        <tr>
                            <td rowspan="2" style={{ width: "10%"  , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>3</td>
                            <td style={{ width: "25%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}><b>LINK (Pre Link)</b></td>
                            <td style={{ width: "65%"  , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px" }} class='column-content'><a href={data?.preLink}>Pre Link</a></td>
                        </tr>
                        <tr>
                            <td style={{ width: "25%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px" }}><b>LINK (Post Link)</b></td>
                            <td style={{ width: "65%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'><a href={data?.preLink}>Post Link</a></td>
                        </tr>
                        <tr>
                            <td rowspan="2" style={{ width: "10%"  , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>4</td>
                            <td style={{ width: "25%"  , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}><b>Program Type</b></td>
                            <td style={{ width: "65%"  , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>{data?.programType}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "25%"  , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}><b>Nomenclature</b></td>
                            <td style={{ width: "65%"  , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px" }} class='column-content'>{data?.NC}</td>
                        </tr>
                        {/* <tr>
                        <td style={{width: "25%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px" }}><b>Duration of the activity</b></td>
                        <td style={{width: "65%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px" }} class='column-content'></td>
                    </tr> */}
                        <tr>
                            <td colspan="1" rowspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>5</td>
                            <td colspan="2"style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>Description</td>
                        </tr>
                        <tr>
                            <td colspan="2" style={{ border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>{data?.Description}</td>
                        </tr>
                        <tr>
                            <td rowspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>6</td>
                            <td colspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>Kindly justify the activity conducted by your respective department will fit as IIC event</td>
                        </tr>
                        <tr>
                            <td colspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>{data?.oActivity}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>7</td>
                            <td colspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>Start and End date of the event:  {Moment(data?.template?.start_date).format(dateFormat.ReportDateFormat)} to {Moment(data?.template?.end_date).format(dateFormat.ReportDateFormat)}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "10%", border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>8</td>
                            <td colspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>Mention minimum number of students (Event): {data?.participants} </td>
                        </tr>
                        <tr>
                            <td style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse", padding:"10px"}}>9</td>
                            <td colspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px" }} class='column-content'>Mention minimum number faculty (Event): {data?.faculty}</td>
                        </tr>
                        {/* <tr>
                            <td style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>10</td>
                            <td colspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content' > {data?.objective}</td>
                        </tr> */}
                        <tr>
                            <td rowspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>10</td>
                            <td colspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>Objective of the event in 3 words (90 Characters) only:</td>
                        </tr>
                        <tr>
                            <td colspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content' id="Objective"></td>
                        </tr>
                        {/* <tr>
                            <td style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>11</td>
                            <td colspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content' >Benefit of the activity in 5 words (120 Characters) only:{data?.outcomes}</td>
                        </tr> */}
                        <tr>
                            <td rowspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>11</td>
                            <td colspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>Benefit of the activity in 5 words (120 Characters) only:</td>
                        </tr>
                        <tr>
                            <td colspan="2" style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content' id="outcomes"></td>
                        </tr>
                        <tr>
                            <td style={{ width: "10%", border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>12</td>
                            <td style={{ width: "25%" , border: "1px solid black" , borderCollapse: "collapse", padding:"10px"}}><b>Video URL</b></td>
                            <td style={{ width: "65%" , border: "1px solid black" , borderCollapse: "collapse", padding:"10px"}} class='column-content'>{data?.vUrl}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "10%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}>13</td>
                            <td colspan="2" style={{border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}} class='column-content'>PHOTOGRAPHS</td>
                        </tr>
                    </table>

                    <table width="100%" align="center" class="report-table">
                        <tr>
                            <td style={{width: "50%", border: "1px solid black" ,borderCollapse: "collapse", padding: "10px"}} align= 'center'>
                                <img src={data?.EventsPhotos ? data?.EventsPhotos[0]?.imageUrl?.replace("itmatic.io","codebrigade.in") : ''} width="300" height="200" />
                            </td>
                            <td style={{width: "50%", border: "1px solid black" ,borderCollapse: "collapse", padding: "10px"}} align= 'center'>
                                <img src={data?.EventsPhotos ? data?.EventsPhotos[1]?.imageUrl?.replace("itmatic.io","codebrigade.in") : ''} width="300" height="200" />
                            </td>
                        </tr>
                        <tr>
                        <td style={{width: "50%", border: "1px solid black" ,borderCollapse: "collapse", padding: "10px"}} align= 'center'>
                                <img src={data?.EventsPhotos ? data?.EventsPhotos[2]?.imageUrl?.replace("itmatic.io","codebrigade.in") : ''} width="300" height="200" />
                            </td>
                            <td style={{width: "50%", border: "1px solid black" ,borderCollapse: "collapse", padding: "10px"}} align= 'center'>
                                <img src={data?.EventsPhotos ? data?.EventsPhotos[3]?.imageUrl?.replace("itmatic.io","codebrigade.in") : ''} width="300" height="200" />
                            </td>
                        </tr>
                    </table>

                    {/* {data?.EventsPhotos &&  */}

                    {/* <table width="920px" style={{maxWidth:"100%"}} align="center" cellspacing='0' cellpadding='10'>
                        <tr>
                            <td style={{ width: "50%", border: "1px solid black" , borderCollapse: "collapse", padding:"10px"}} align='center'><img style={{ maxWidth: "100%", height:"300px" }} src={data?.EventsPhotos ? data?.EventsPhotos[0]?.imageUrl:null}></img></td>

                            <td style={{ width: "50%", border: "1px solid black" , borderCollapse: "collapse", padding:"10px"}} align='center'><img style={{ maxWidth: "100%", height:"300px" }} src={data?.EventsPhotos ? data?.EventsPhotos[1]?.imageUrl:null} alt="Logo" /></td>
                        </tr>
                        <tr>
                            <td style={{ width: "50%", border: "1px solid black" , borderCollapse: "collapse", padding:"10px"}} align='center'><img style={{ maxWidth: "100%", height:"300px" }} src={data?.EventsPhotos ? data?.EventsPhotos[2]?.imageUrl:null} alt="Logo" /></td>

                            <td style={{ width: "50%", border: "1px solid black" , borderCollapse: "collapse", padding:"10px"}} align='center'><img style={{ maxWidth: "100%", height:"300px" }} src={data?.EventsPhotos ? data?.EventsPhotos[3]?.imageUrl:null} alt="Logo" /></td>
                        </tr>
                    </table> */}

                    <table align="center" class="events-detail-table">
                        <tr>
                            <td style={{ width: "50%" , border: "1px solid black" , borderCollapse: "collapse" , padding:"10px"}}><b>Name of Department:</b></td>
                            <td style={{ width: "50%" , border: "1px solid black" , borderCollapse: "collapse", padding:"10px" }} class='column-content'>{data?.template?.department?.name}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "50%" , border: "1px solid black", borderCollapse: "collapse" , padding:"10px"}}><b>Name of Organiser with Mail ID & Contact Number: </b></td>
                            <td style={{ width: "50%" , border: "1px solid black", borderCollapse: "collapse", padding:"10px" }} class='column-content'>{data?.template?.organized_by}</td>
                        </tr>
                        <tr>
                            <td colspan="2" style={{ width: "100%" , border: "1px solid black", borderCollapse: "collapse" , padding:"10px"}}><b>Resource Person Details :</b></td>
                        </tr>
                        {data?.template?.resource_persons.map(d=>{                       
                            return<><tr>
                           <td style={{ width: "50%", border: "1px solid black", borderCollapse: "collapse" , padding:"10px"}}><b>Name :</b></td>
                            <td style={{ width: "50%" , border: "1px solid black", borderCollapse: "collapse" , padding:"10px"}} class='column-content'><div>{d.name}</div></td>
                        </tr>
                        <tr>
                            <td style={{ width: "50%" , border: "1px solid black", borderCollapse: "collapse" , padding:"10px"}}><b>Designation :</b></td>
                            <td style={{ width: "50%" , border: "1px solid black", borderCollapse: "collapse" , padding:"10px"}} class='column-content'><div>{d?.designation}</div></td>
                        </tr>
                        <tr>
                            <td style={{ width: "50%" , border: "1px solid black", borderCollapse: "collapse" , padding:"10px"}}><b>Organization :</b></td>
                            <td style={{ width: "50%" , border: "1px solid black", borderCollapse: "collapse" , padding:"10px" }} class='column-content'><div>{d?.description}</div></td>
                        </tr>
                        <tr>
                            <td style={{ width: "50%", border: "1px solid black", borderCollapse: "collapse" , padding:"10px"}}><b>Mail ID :</b></td>
                            <td style={{ width: "50%" , border: "1px solid black", borderCollapse: "collapse" , padding:"10px"}} class='column-content'><div>{d?.email}</div></td>
                        </tr></>})}
                    </table>

                </div>
            </div>
        );

    };

export default IicReport;